import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import './styles.scss'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="not-found">
      <div className="not-found__card">
        <div className="not-found__card__label">
          <span className="tracking-tag">TRACKING #</span>
          <span className="code">404</span>
        </div>

        <div className="not-found__card__icon">
          <FontAwesomeIcon icon={solid('box-open')} />
        </div>

        <h1 className="not-found__card__title">Page Not Found</h1>

        <div className="not-found__card__status">
          <span className="status-label">STATUS</span>
          <span className="status-badge">Lost in Transit</span>
        </div>

        <p className="not-found__card__desc">
          The page you're looking for seems to have gone missing in transit.
          Let us redirect your shipment back to safety.
        </p>

        <button className="not-found__card__btn" onClick={() => navigate('/')}>
          <FontAwesomeIcon icon={solid('arrow-left')} />
          Return to Home
        </button>
      </div>

      <p className="not-found__copy">
        © {new Date().getFullYear()} Expeditors Logistics
      </p>
    </div>
  )
}

export default NotFound
